import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { useCount } from 'modules/quickActionsMenu/hooks';
import { SetCount } from 'modules/quickActionsMenu/types';
import { IndexPageTemplate } from 'modules/templateIndex';
import { TemplatePreviewImage } from 'modules/templateIndex/components/TemplatePreviewImage';
import { PreviewThumbnailsById } from 'modules/templateIndex/hooks/usePreviewThumbnails';
import { Spinner } from 'ui/spinner';
import { Item } from '../Item';
import { Medium, StyledThumbnailWrapper } from '../Item/Item.styled';
import { CommandGroup, CommandLoading, EmptyState } from '../Styled';
import { useTemplateSearch } from './useTemplateSearch';

export const TEMPLATE_SEARCH_TEXT = {
  heading: 'Templates',
  emptyStateMessage: 'Template search results placeholder',
};

const { emptyStateMessage, heading } = TEMPLATE_SEARCH_TEXT;

export const TemplateSearch = ({ setCount }: { setCount: SetCount }) => {
  const { navigate, debouncedSearchTerm = '' } = useQuickActionsMenuContext();
  const { info, isLoading, templates, thumbnails } = useTemplateSearch(debouncedSearchTerm);
  useCount({ count: info?.count, setCount });

  if (isLoading) {
    return (
      <CommandLoading>
        <Spinner />
      </CommandLoading>
    );
  }

  return (
    <>
      {templates.length === 0 ? (
        <EmptyState>{emptyStateMessage}</EmptyState>
      ) : (
        <CommandGroup heading={heading}>
          {templates.map((template) => (
            <Item
              Icon={
                <StyledThumbnailWrapper>
                  <TemplatePreviewImage
                    template={template as IndexPageTemplate}
                    previewThumbnailsById={thumbnails as PreviewThumbnailsById}
                  />
                </StyledThumbnailWrapper>
              }
              id={template.id}
              key={template.id}
              name={template.name}
              onSelect={() =>
                navigate({
                  id: template.id,
                  pageName: 'Template details page',
                  path: `/templates/editor?templateId=${template.id}`,
                })
              }
              suffix={<Medium>{template.messageMedium}</Medium>}
              value={`${template.name} ${template.id}`}
            />
          ))}
        </CommandGroup>
      )}
    </>
  );
};
